import React from 'react';

interface CollapsibleSectionProps {
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
  count?: number;
  children: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  isExpanded,
  onToggle,
  count,
  children
}) => {
  return (
    <div className="collapsible-section">
      <div className="collapsible-header" onClick={onToggle}>
        <h3 className="collapsible-title">
          {title}
          {count !== undefined && (
            <span className="count-badge">({count})</span>
          )}
        </h3>
        <span className={`collapsible-icon ${isExpanded ? 'expanded' : 'collapsed'}`}>
          ▼
        </span>
      </div>
      {isExpanded && (
        <div className="collapsible-content">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
